import { compact, flatMap, map, sumBy, values } from "lodash-es";
import { PowerProjection } from "../types";
import {
  ENERGY_TECHNOLOGIES,
  ProjectionsByTechnology,
} from "../types/projections";

export function createEmptyProjections(): ProjectionsByTechnology {
  return Object.fromEntries(
    ENERGY_TECHNOLOGIES.map((tech) => [tech, null])
  ) as ProjectionsByTechnology;
}

/**
 * Parse projections from API response
 * @param projectionData - The raw projection data from API
 * @returns Parsed projections by technology
 */
export function parseProjectionsFromApi(
  projectionData: Record<string, any> | null | undefined
): ProjectionsByTechnology {
  if (!projectionData) {
    return createEmptyProjections();
  }

  return Object.fromEntries(
    ENERGY_TECHNOLOGIES.map((tech) => [
      tech,
      projectionData[`${tech}_projection`] || null,
    ])
  ) as ProjectionsByTechnology;
}

/**
 * Calculate total projection across all technologies
 * @param projections - Projections by technology
 * @returns Total production sum
 */
export function calculateTotalProjection(
  projections: ProjectionsByTechnology
): number {
  const supportedProjections = compact(
    map(ENERGY_TECHNOLOGIES, (tech) => projections[tech])
  );

  const allMonthlyValues = flatMap<PowerProjection, number>(
    supportedProjections,
    values
  );

  return sumBy(allMonthlyValues, (value) => value || 0);
}
